module.exports = __webpack_public_path__ + "img/192.95212ea0.jpg";